export default __webpack_public_path__ + "static/05-7b08fdc15bb773c6a1b04a4e0620b161.jpg";